import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import ProfileMenu from '../ProfileMenu';
import CustomPopover from '../../components/CustomPopover';
import { IAppState } from '../../common/models/store/IAppState';
import UserLogo from '../../components/UserLogo';
import SearchBar from '../../scenes/GlobalSearch/containers/Search';
import styles from './styles.module.scss';
import Icon from '../../components/Icon';
import Logo from '../../components/Logo';
import { Link } from 'react-router-dom';
import { Routes } from '../../common/enums/Routes';
import { FormattedMessage } from 'react-intl';
import Tooltip from '../../components/Tooltip';
import { User } from '../../common/models/user/User';

interface IHeaderProps {
  user: User;
}

const Header: FunctionComponent<IHeaderProps> = ({ user }) => (
  <div className={`page-indent ${styles.header} d-flex justify-content-between`}>
    <Logo />
    <SearchBar />
    <div className="d-flex flex-row align-items-center">
      <Link to={Routes.Settings} className={styles.actionsItem}>
        <Tooltip content={<FormattedMessage id="iconButtonLable.settings" defaultMessage="Settings" />}>
          <Icon icon="gear" className={`${styles.icon} hover-icon-stroke`} />
        </Tooltip>
      </Link>
      <CustomPopover
        placement="bottom-end"
        rootClose
        trigger={(
          <UserLogo
            user={user}
            size="40px"
            border
            fontSize="1rem"
            hideTooltip
          />
        )}
      >
        <ProfileMenu />
      </CustomPopover>
    </div>
  </div>
);

const mapStateToProps = (state: IAppState) => {
  const { user: { user, loading } } = state;

  return {
    user: user as User,
    loading
  };
};

export default connect(mapStateToProps)(Header);
